module.exports = __webpack_public_path__ + "media/images/flags/4x3/sxm-2175354a7aac47007546c93f3f2a571d.svg";